import { css } from '@emotion/react'

export const loader = css`
  margin: 32px auto;
`
